export default __webpack_public_path__ + "static/media/card-wagon.d3172750.jpg";